import React, { Component } from "react";
import { can } from "../../utils/permission";
import {
  company,
  loading,
  NavbarAdmin,
  Pagination,
  Modal,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  t,
  ActionIconButton,
  ACTION_ICONS,
  fmtInt,
} from "../../components/CustomComponent.js";

export default class CustomerWarrantyConditions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",

      page: 1,
      page_size: 10,
      count: 0,
      data: [],

      modal_create: false,
      modal_update: false,

      // Form states
      uid: "",
      company_id: company?.id,
      code: "",
      name: "",
      is_active: "Active",
    };
  }

  async componentDidMount() {
    loading(false);
    this.Get(1);
  }

  Get = async (page) => {
    const { filter_search, page_size } = this.state;
    loading(true);

    const result = await GET("admin/customer-warranty-conditions", {
      page_size,
      page,
      data_search: filter_search || "",
    });

    if (result?.status) {
      this.setState({
        data: result.data || [],
        count: result.pagination?.count || 0,
        page,
      });
    }

    loading(false);
  };

  getNextCode = () => {
    const { data } = this.state;
    if (!data.length) return "WC-001";
    const maxNum = data.reduce((max, item) => {
      const match = item.code?.match(/^WC-(\d+)$/);
      if (match) return Math.max(max, parseInt(match[1], 10));
      return max;
    }, 0);
    return `WC-${String(maxNum + 1).padStart(3, "0")}`;
  };

  openCreate = () =>
    this.setState({
      modal_create: true,
      modal_update: false,
      uid: "",
      code: "",
      name: "",
      is_active: "Active",
    });

  openEdit = (item) =>
    this.setState({
      modal_create: false,
      modal_update: true,
      uid: item.uid,
      code: item.code || "",
      name: item.name || "",
      is_active: item.is_active ? "Active" : "Inactive",
    });

  handleSave = async () => {
    const { uid, company_id, code, name, is_active } = this.state;

    if (!name.trim()) {
      alert("", "warning", t("warning"), t("cwc_validate_name"));
      return;
    }

    if (await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel"))) {
      loading(true);

      const body = {
        company_id,
        code: code.trim(),
        name: name.trim(),
        is_active: is_active === "Active",
      };

      const result = !uid
        ? await POST("admin/customer-warranty-conditions", body)
        : await PUT("admin/customer-warranty-conditions/" + uid, body);

      if (result?.status === true) {
        alert("#", "success", t("success"), t("save_success"));
        this.setState({ modal_create: false, modal_update: false });
        this.Get(this.state.page);
      } else {
        alert("", "warning", t("warning"), result?.message || "An error occurred.");
      }
      loading(false);
    }
  };

  handleDelete = async (uid) => {
    if (await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel"))) {
      loading(true);
      const result = await DELETE("admin/customer-warranty-conditions/" + uid, null);
      if (result?.status) {
        alert("#", "success", t("success"), t("delete_success"));
        this.Get(this.state.page);
      } else {
        alert("", "warning", t("warning"), result?.message || "An error occurred.");
      }
      loading(false);
    }
  };

  render() {
    const {
      data, count, page, page_size,
      filter_search, modal_create, modal_update,
      code, name, is_active,
    } = this.state;

    return (
        <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarAdmin />
            <div className="body p-4 mt-3">
                {/* Header */}
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
                    <div>
                        <h3 className="fw-bold mb-1 text-dark">{t("cwc_title")}</h3>
                        <div className="text-secondary text-14">{t("cwc_desc")}</div>
                    </div>
                </div>

                {/* Filter Toolbar */}
                <div className="rounded-4 bg-white p-3 mb-3 shadow-sm border-0">
                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                        <div className="d-flex flex-wrap gap-2 flex-grow-1">
                            <div className="position-relative">
                                <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{""}</span>
                                <input
                                    type="text"
                                    className="form-control ps-5 wpx-350"
                                    style={{ height: "38px" }}
                                    placeholder={t("cwc_search_placeholder")}
                                    value={filter_search}
                                    onChange={(e) => this.setState({ filter_search: e.target.value })}
                                    onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
                                />
                            </div>
                            <div className="d-flex gap-2">
                                <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.Get(1)}>
                                    {t("filter")}
                                </button>
                                <button className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.setState({ filter_search: "" }, () => this.Get(1))}>
                                    {t("clear_all")}
                                </button>
                            </div>
                        </div>
                        {can("customer-warranty-condition.create") && (
                          <button className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center" onClick={this.openCreate}>
                              <span className="me-2 text-16">+</span> {t("cwc_add_btn")}
                          </button>
                        )}
                    </div>
                </div>

                {/* Table */}
                <div className="bg-white rounded-4 shadow-sm overflow-hidden">
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0" style={{ minWidth: "700px" }}>
                            <thead>
                                <tr className="text-dark fw-bold text-12 border-bottom border-light">
                                    <th className="py-3 px-3 border-0 wpx-150">{t("cwc_col_code")}</th>
                                    <th className="py-3 px-3 border-0">{t("cwc_col_name")}</th>
                                    <th className="py-3 px-3 border-0 text-center wpx-120">{t("status")}</th>
                                    <th className="py-3 px-3 border-0 text-center wpx-120">{t("actions")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.length === 0 ? (
                                    <tr>
                                        <td colSpan={4} className="text-center text-secondary py-5">
                                            <div className="d-flex flex-column align-items-center gap-2">
                                                <span>{t("no_data")}</span>
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    data.map((item, idx) => (
                                        <tr key={item.uid || idx} className="border-bottom border-light bg-white">
                                            <td className="px-3">
                                                <div className="text-primary text-14 fw-semibold">{item.code || "-"}</div>
                                            </td>
                                            <td className="px-3">
                                                <div className="text-dark text-14">{item.name || "-"}</div>
                                            </td>
                                            <td className="text-center">
                                                {item.is_active ? (
                                                    <span className="text-success text-12 fw-bold bg-success-light px-2 py-1 rounded-pill">{t("active")}</span>
                                                ) : (
                                                    <span className="text-secondary text-12 fw-bold bg-light px-2 py-1 rounded-pill border">{t("inactive")}</span>
                                                )}
                                            </td>
                                            <td className="text-center">
                                                <div className="d-flex align-items-center gap-2 justify-content-center">
                                                    {can("customer-warranty-condition.update") && (
                                                      <ActionIconButton label={t("edit")} icon={ACTION_ICONS.edit} variant="warning" onClick={() => this.openEdit(item)} />
                                                    )}
                                                    {can("customer-warranty-condition.delete") && (
                                                      <ActionIconButton label={t("delete")} icon={ACTION_ICONS.delete} variant="danger" onClick={() => this.handleDelete(item.uid)} />
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer Pagination */}
                <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap text-secondary text-12 gap-2">
                    <div>
                        {t("showing")} {count === 0 ? 0 : fmtInt((page - 1) * page_size + 1)}-{fmtInt((page - 1) * page_size + data.length)} {t("of")} {fmtInt(count)} {t("cwc_count")}
                    </div>
                    <Pagination className="mb-0" count={Math.ceil(count / page_size) || 1} page={page} showFirstButton={false} showLastButton={false} onChange={(_, p) => this.Get(p)} />
                </div>
            </div>

            {/* MODAL: CREATE / EDIT */}
            <Modal show={modal_create || modal_update} onHide={() => this.setState({ modal_create: false, modal_update: false })} centered contentClassName="border-0 rounded-4 shadow-lg">
                <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
                    <h5 className="fw-bold mb-0 text-dark">{modal_update ? t("cwc_modal_edit") : t("cwc_modal_create")}</h5>
                </Modal.Header>
                <Modal.Body className="p-4 bg-white">
                    <div className="row g-3">
                        {/* Code */}
                        <div className="col-12">
                            <label className="form-label text-14 text-dark mb-2">{t("cwc_col_code")}</label>
                            <input type="text" className="form-control py-2" placeholder={t("cwc_code_placeholder")} value={code} onChange={(e) => this.setState({ code: e.target.value })} />
                        </div>

                        {/* Name */}
                        <div className="col-12">
                            <label className="form-label text-14 text-dark mb-2">
                                {t("cwc_col_name")} <span className="text-danger">*</span>
                            </label>
                            <textarea className="form-control py-2" rows={3} placeholder={t("cwc_name_placeholder")} value={name} onChange={(e) => this.setState({ name: e.target.value })} />
                        </div>

                        {/* Status */}
                        <div className="col-12 mt-2">
                            <div className="form-check mb-2">
                                <input
                                    className="form-check-input pointer"
                                    type="checkbox"
                                    id="cwcStatusCheck"
                                    checked={is_active === "Active"}
                                    onChange={(e) => this.setState({ is_active: e.target.checked ? "Active" : "Inactive" })}
                                />
                                <label className="form-check-label text-14 text-dark fw-semibold pointer" htmlFor="cwcStatusCheck">
                                    {t("status")}
                                </label>
                            </div>
                            <div className="d-flex gap-4 ms-1">
                                <div className="form-check d-flex align-items-center gap-2">
                                    <input
                                        className="form-check-input mt-0 pointer"
                                        type="radio"
                                        name="cwcStatus"
                                        id="cwcActive"
                                        checked={is_active === "Active"}
                                        onChange={() => this.setState({ is_active: "Active" })}
                                    />
                                    <label className="form-check-label text-dark text-14 pointer" htmlFor="cwcActive">
                                        {t("active")}
                                    </label>
                                </div>
                                <div className="form-check d-flex align-items-center gap-2">
                                    <input
                                        className="form-check-input mt-0 pointer"
                                        type="radio"
                                        name="cwcStatus"
                                        id="cwcInactive"
                                        checked={is_active === "Inactive"}
                                        onChange={() => this.setState({ is_active: "Inactive" })}
                                    />
                                    <label className="form-check-label text-dark text-14 pointer" htmlFor="cwcInactive">
                                        {t("inactive")}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
                    <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={() => this.setState({ modal_create: false, modal_update: false })}>
                        {t("cancel")}
                    </button>
                    <button
                        className="btn btn-primary px-4 py-2 d-flex align-items-center rounded-3 fw-bold text-white shadow-sm"
                        style={{ backgroundColor: "#2563eb", borderColor: "#2563eb" }}
                        onClick={this.handleSave}
                    >
                        <span className="icon me-2">{""}</span> {t("save")}
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
  }
}
